import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const savedCart = localStorage.getItem('krishna_cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('krishna_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, quantity, unit) => {
    const existingItemIndex = cart.findIndex(
      item => item.product.id === product.id && item.unit === unit
    );

    if (existingItemIndex > -1) {
      const newCart = [...cart];
      newCart[existingItemIndex].quantity += quantity;
      setCart(newCart);
    } else {
      setCart([...cart, { product, quantity, unit }]);
    }
  };

  const removeFromCart = (productId, unit) => {
    setCart(cart.filter(item => !(item.product.id === productId && item.unit === unit)));
  };

  const updateQuantity = (productId, unit, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId, unit);
      return;
    }
    setCart(cart.map(item =>
      item.product.id === productId && item.unit === unit
        ? { ...item, quantity: newQuantity }
        : item
    ));
  };

  const clearCart = () => {
    setCart([]);
    localStorage.removeItem('krishna_cart');
  };

  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getTotalItems
      }}
    >
      {children}
    </CartContext.Provider>
  );
};